const apiUrl = process.env.REACT_APP_API_URL;

// Lista las penalizaciones ligadas a (práctica, alumno).
export const GetPenalitzacionsPracticaUsuari = async (id_practica: string, id_usuari: string) => {
    try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(
            `${apiUrl}:8061/jutge/practica/${id_practica}/usuaris/${id_usuari}/penalitzacions`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });
        if (!response.ok) return [];
        const jsonData = await response.json();
        return Array.isArray(jsonData) ? jsonData : [];
    } catch (error) {
        console.log('Error obtenint penalitzacions:', error);
        return [];
    }
};
